<template>
  <div :ref="guid" class="browser-block" :style="myBlockProps.getStyles(visible)" @scroll="autoScrolling" >
    <div v-for="link in myLinks" :key="link.guid" :ref="getLinkGuid(link.guid)"
         :style="getLinkStyles(link.guid)"
         @click="selectLink(link.guid)">{{link.text.getText(selectedLanguage)}}
    </div>
  </div>
</template>

<script>
import Block from './Block.vue';

import { BlockProps, BrowserItem, TextProps } from '../models';

export default {
  name: 'browser-block',
  extends: Block,
  props: {
    scrollTime: { type: Number, default: 1000 },
    contentBlockGuid: { type: String, required: true },
    links: { type: Array, required: true, default: () => [{}] },
    textProps: { type: Object, required: true, default: () => ({}) },
    selectedTextProps: { type: Object, required: true, default: () => ({}) },
    childBlockProps: { type: Object, required: true, default: () => ({}) },
    selectedChildBlockProps: { type: Object, required: true, default: () => ({}) },
  },
  created() {
    this.$store.dispatch('setSelectedBlock', { containerGuid: this.contentBlockGuid, selectedGuid: this.firstLinkGuid });
    const itemsOrder = this.myLinks.map((_) => _.guid);
    this.$store.dispatch('setBrowserItemsOrder', { containerGuid: this.contentBlockGuid, itemsOrder });
  },
  computed: {
    myLinks() {
      return this.links.map((_) => new BrowserItem(_));
    },
    firstLinkGuid() {
      const firstLink = this.myLinks[0];
      return firstLink ? firstLink.guid : '';
    },
    myChildBlockProps() {
      return new BlockProps(this.childBlockProps);
    },
    mySelectedChildBlockProps() {
      return new BlockProps(this.selectedChildBlockProps);
    },
    myTextProps() {
      return new TextProps(this.textProps);
    },
    mySelectedTextProps() {
      return new TextProps(this.selectedTextProps);
    },
    selectedLinkId() {
      return this.$store.getters.getSelectedLinkId(this.contentBlockGuid);
    },
    containerRef() {
      return this.$refs[this.guid];
    },
    selectedLinkRef() {
      return this.$refs[`${this.guid}-${this.selectedLinkId}`] ? this.$refs[`${this.guid}-${this.selectedLinkId}`][0] : '';
    },
    scrollTargetPoint() {
      const { selectedLinkRef } = this;
      const { containerRef } = this;
      const containerMiddlePoint = containerRef.offsetWidth / 2;
      const itemOffsetMiddlePoint = selectedLinkRef.offsetLeft - containerRef.offsetLeft + (selectedLinkRef.offsetWidth / 2);

      return itemOffsetMiddlePoint - containerMiddlePoint;
    }
  },
  watch: {
    selectedLinkId() {
      this.scrollToTarget();
    }
  },
  data() {
    return {
      scrollTimer: null,
    };
  },
  methods: {
    scrollToTarget() {
      // Fallback so Safari doesn't spit out errors, as it does not support scroll to.
      const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
      if (supportsNativeSmoothScroll) {
        this.containerRef.scrollTo(this.scrollTargetPoint, 0);
      }
    },
    getLinkGuid(linkId) {
      return `${this.guid}-${linkId}`;
    },
    getLinkStyles(linkId) {
      const textProps = linkId === this.selectedLinkId ? this.mySelectedTextProps.getStyles() : this.myTextProps.getStyles();
      const blockProps = linkId === this.selectedLinkId ? this.mySelectedChildBlockProps.getStyles() : this.myChildBlockProps.getStyles();
      return { ...textProps, ...blockProps };
    },
    autoScrolling() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(
        () => this.scrollToTarget(),
        this.scrollTime
      );
    },
    selectLink(linkId) {
      this.$store.dispatch('setSelectedBlock', { containerGuid: this.contentBlockGuid, selectedGuid: linkId });
      this.scrollToTarget();
    }
  }
};
</script>

<style lang="scss" scoped>
  .browser-block {
    div {
      cursor: pointer;
      white-space: nowrap;
    }
  }
</style>
